module.exports = {
      id: "close-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#close",
      toString: function () {
        return this.url;
      }
    }